<div class="login-form">
  <form (keydown.enter)="enterAction($event)" class="mb-2">
    <div>
      <div class="row" *ngIf="description">
        <div class="col-12 text-center">
          <p class="lead text-dark">{{ description }}</p>
        </div>
      </div>
      <div class="row" *ngIf="authenticationError">
        <div class="col-12 text-center">
          <div class="alert alert-danger" jhiTranslate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div>
        </div>
      </div>
      <div class="row" *ngIf="registrationError">
        <div class="col-12 text-center">
          <div class="alert alert-danger" jhiTranslate="login.messages.error.registration" [translateValues]="{ transporterShopName: transporter?.shopName }">
            <strong>Failed to sign in!</strong> Please check your credentials and try again.
          </div>
        </div>
      </div>
      <div class="row" *ngIf="activationEmailNotSent">
        <div class="col-12 text-center">
          <div class="alert alert-danger" jhiTranslate="login.messages.error.activationEmailNotSent">
            <strong>Account activation email has not been sent!</strong> Please verify your email address or contact the support.
          </div>
        </div>
      </div>
      <div class="row" *ngIf="activationError">
        <div class="col-12 text-center">
          <div class="alert alert-warning">
            <span jhiTranslate="login.messages.warning.requiredActivation"> <strong>Failed to sign in!</strong> Activate your account before going further. </span>
            (<u jhiTranslate="login.buttons.resendAnEmail" (click)="resendAccountActivationEmail()">Resend the email</u>).
          </div>
        </div>
      </div>
      <div class="row" *ngIf="suggestToUseUser">
        <div class="col-12 text-center">
          <div
            data-id-cypress="suggest-to-use-user"
            class="alert alert-warning"
            jhiTranslate="login.messages.warning.suggestToUseUser"
            [translateValues]="{ transporterShopName: transporter?.shopName }"
          >
            <strong>User already use!</strong> If you want to use this user on this shop.
          </div>
        </div>
      </div>
      <div class="row" *ngIf="helpFromSupportError">
        <div class="col-12 text-center">
          <div class="alert alert-warning" jhiTranslate="login.messages.warning.needHelpFromSupporService" [translateValues]="{ transporterShopName: transporter?.shopName }">
            <strong>Failed to sign up!</strong> Contact the support for getting help.
          </div>
        </div>
      </div>
      <div class="row" *ngIf="activationEmailSent">
        <div class="col-12 text-center">
          <div class="alert alert-success" jhiTranslate="login.messages.success.activationEmailSent">
            <strong>Account activation email sent!</strong> A new account activation email has been sent.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <jhi-bary-input-text
            #firstFocus
            data-id-cypress="username"
            [control]="loginForm.controls.email"
            [label]="'login.email.label' | translate"
            [id]="'username'"
          ></jhi-bary-input-text>
        </div>
      </div>
      <div class="row" *ngIf="step == 1 || step == 3">
        <div class="col-12">
          <jhi-bary-input-password
            data-id-cypress="password"
            [control]="loginForm.controls.password"
            [label]="'login.password.label' | translate"
            [id]="'password'"
          ></jhi-bary-input-password>
        </div>
        <div class="col-12 mt-2">
          <div class="d-flex align-items-center">
            <jhi-bary-input-checkbox [control]="loginForm.controls.rememberMe" [id]="'rememberMe'" [label]="'login.rememberMe.label' | translate"></jhi-bary-input-checkbox>
            <jhi-bary-link class="ml-auto" [label]="'login.forgotPassword.label' | translate" (click)="handleClick({ reset: true })"></jhi-bary-link>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!--Footer-->
  <div class="justify-content-end">
    <jhi-bary-button
      [block]="true"
      *ngIf="showSuggestToUseUserBt()"
      color="primary"
      data-id-cypress="btn-suggest-to-use-user"
      id="bt-suggestToUseUser"
      [label]="'login.buttons.suggestToUseUser' | translate"
      (clickEvent)="handleClick({ suggestToUseUser: true })"
    ></jhi-bary-button>
    <jhi-bary-button
      [block]="true"
      data-id-cypress="btn-next-step-login"
      *ngIf="showNextBt()"
      color="primary"
      id="bt-next"
      [disabled]="!loginForm.controls.email.value || authenticationError || registrationError || activationError || helpFromSupportError"
      [label]="'login.buttons.next' | translate"
      (clickEvent)="handleClick({ next: true })"
    ></jhi-bary-button>
    <jhi-bary-button
      [block]="true"
      *ngIf="showLoginBt()"
      id="bt-login"
      data-id-cypress="btn-login"
      [disabled]="!(loginForm.controls.email.value && loginForm.controls.password.value)"
      color="primary"
      [label]="'login.buttons.login' | translate"
      (clickEvent)="handleClick({ login: true })"
    ></jhi-bary-button>
    <jhi-bary-button
      [block]="true"
      *ngIf="showForceLoginBt()"
      id="bt-forceLogin"
      data-id-cypress="btn-login"
      [disabled]="!(loginForm.controls.email.value && loginForm.controls.password.value)"
      color="primary"
      [label]="'login.buttons.login' | translate"
      (clickEvent)="handleClick({ forceLogin: true })"
    ></jhi-bary-button>

    <!-- ALTERNATIVE ACTION -->
    <div class="row w-100 no-gutters" *ngIf="isLoginType">
      <div class="col-12 text-center">
        <hr class="bary-hr" />
        <p jhiTranslate="login.newOnShopMessage" [translateValues]="{ transporterShopName: transporter?.shopName }">Nouveau sur la platforme ?</p>
      </div>
      <div class="col-12">
        <jhi-bary-button
          [outline]="true"
          [block]="true"
          [size]="'sm'"
          id="bt-createAccount"
          data-id-cypress="btn-create-account"
          (clickEvent)="handleClick({ createAccount: true })"
          [label]="'login.buttons.createAccount' | translate"
          color="primary"
        ></jhi-bary-button>
      </div>
    </div>
    <div class="row w-100 no-gutters" *ngIf="!isLoginType && !showForceLoginBt()">
      <div class="col-12 text-center">
        <hr class="bary-hr" />
        <p jhiTranslate="login.haveAccountMessage" [translateValues]="{ transporterShopName: transporter?.shopName }">Vous possédez déjà un compte sur la palteforme ?</p>
      </div>
      <div class="col-12">
        <jhi-bary-button
          [outline]="true"
          [block]="true"
          [size]="'sm'"
          id="bt-switchToLogin"
          *ngIf="!isLoginType && !showForceLoginBt()"
          (clickEvent)="handleClick({ switchToLogin: true })"
          [label]="'login.buttons.login' | translate"
          color="primary"
        ></jhi-bary-button>
      </div>
    </div>
  </div>
</div>
